export default __webpack_public_path__ + "static/media/resume.e03568ca.pdf";